/**
 * @generated SignedSource<<63efc1134fb045ae977fb248500ff77d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraProjectStatus = "ACTIVE" | "ARCHIVED" | "DELETED" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type Nav4ProjectMenuItem$data = {
  readonly projectType: JiraProjectType;
  readonly status: JiraProjectStatus;
  readonly " $fragmentSpreads": FragmentRefs<"JcsProjectMenu" | "JiraBusinessProjectMenu" | "JpdProjectMenu" | "JpdProjectMenuLoader_project" | "JsmProjectMenu" | "JswProjectMenu">;
  readonly " $fragmentType": "Nav4ProjectMenuItem";
};
export type Nav4ProjectMenuItem$key = {
  readonly " $data"?: Nav4ProjectMenuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectMenuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4ProjectMenuItem",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "status"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectType"
      },
      "action": "THROW"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraBusinessProjectMenu"
    },
    {
      "kind": "FragmentSpread",
      "name": "JsmProjectMenu"
    },
    {
      "kind": "FragmentSpread",
      "name": "JpdProjectMenu"
    },
    {
      "kind": "FragmentSpread",
      "name": "JswProjectMenu"
    },
    {
      "kind": "FragmentSpread",
      "name": "JcsProjectMenu"
    },
    {
      "kind": "FragmentSpread",
      "name": "JpdProjectMenuLoader_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "5f6f4ebdcbc612c4d3122fb14077c5b9";

export default node;
